/**
 * @generated SignedSource<<44691a68130009e20994aad9d0d592a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_item$data = {
  readonly address: {
    readonly country: string | null;
  } | null;
  readonly " $fragmentType": "useFDFQuoteVariant_item";
};
export type useFDFQuoteVariant_item$key = {
  readonly " $data"?: useFDFQuoteVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFDFQuoteVariant_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "9b1047ee8a61989071da3f3e892ade80";

export default node;
